// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e05cee7c","453":"3437140d"}[chunkId] + ".chunk.js";
};